import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    const searchInput = this.refs.searchInput;
    const searchClear = this.refs.searchClear;
    const noResults = this.refs.noResults;

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        const query = searchInput.value.toLowerCase().trim();
        let hasMatches = false;

        // Toggle clear button
        if (searchClear) {
          if (query.length > 0) {
            searchClear.classList.remove('hidden');
          } else {
            searchClear.classList.add('hidden');
          }
        }

        // Filter blog post items
        const cards = this.querySelectorAll('.blog-post-item');
        cards.forEach((card) => {
          const title = card.getAttribute('data-title')?.toLowerCase() || '';
          const content = card.getAttribute('data-content')?.toLowerCase() || '';

          if (title.includes(query) || content.includes(query)) {
            card.classList.remove('hidden');
            hasMatches = true;
          } else {
            card.classList.add('hidden');
          }
        });

        // Toggle no results state
        if (noResults) {
          if (query.length > 0 && !hasMatches) {
            noResults.classList.remove('hidden');
          } else {
            noResults.classList.add('hidden');
          }
        }
      });
    }

    if (searchClear && searchInput) {
      searchClear.addEventListener('click', () => {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
        searchInput.focus();
      });
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
